module.exports = __webpack_public_path__ + "static/media/crane.b783d485.svg";